import { uploadedFileSchema } from "./uploadedFileSchema.js";

export const mediaSchema = uploadedFileSchema;
